// extracted by mini-css-extract-plugin
var _1 = "CommentEdit_editor__jD0lS";
export { _1 as "editor" }
